import React, { useState, useRef } from "react";
import { IconClose, IconSource } from "../../../components/Ui/Icon";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";

import { toast } from "react-toastify";
import {
  createIndex,
  uploadIndexDocument,
  activeIndex,
  deactiveIndex,
} from "../../../services/exIndex";

const Create = ({ togglePopup, onSubmited, item }) => {
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const [file, setFile] = useState();
  const [formValue, setFormValue] = useState({
    index_name: item?.index_name,
    priority: item?.priority,
    is_activated: item?.is_activated,
    allow_conflict_resolution: item?.allow_conflict_resolution || false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormValue((preValue) => ({
      ...preValue,
      [`${name}`]: value,
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;

    setFormValue((preValue) => ({
      ...preValue,
      [`${name}`]: checked,
    }));
  };

  const handleUpload = (event) => {
    const file = event.target.files[0];
    setFile(file);
  };

  const uploadDocument = async () => {
    const indexName = item ? item.index_name : formValue.index_name;
    try {
      const formData = new FormData();
      formData.append("uploads", file);
      formData.append("index_name", indexName);

      await uploadIndexDocument(formData);
      setTimeout(() => {
        setLoading(false);
      });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const createNew = async () => {
    if (!file) {
      toast.info("Please select upload document");
      return;
    }
    try {
      setLoading(true);

      await createIndex({ index_name: formValue.index_name });
      await uploadDocument();
      setTimeout(() => {
        setLoading(false);
      });
      togglePopup();
      onSubmited();
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    console.log(formValue);
    if (!item) {
      await createNew();
      return;
    }
    if (formValue.is_activated) {
      await callActiveIndex();
    } else {
      await callDeactiveIndex();
    }
  };

  const callActiveIndex = async () => {
    if (!item) return;
    setLoading(true);
    try {
      const pri = parseInt(formValue.priority);
      await activeIndex({
        index_name: formValue.index_name,
        priority: isNaN(pri) ? 1 : pri,
        allow_conflict_resolution: formValue.allow_conflict_resolution,
      });
      setLoading(false);
      toast.success("Successfully");
      onSubmited();
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    } finally {
    }
  };

  const callDeactiveIndex = async () => {
    if (!item) return;
    setLoading(true);
    try {
      await deactiveIndex({ index_name: item.index_name });

      setLoading(false);
      toast.success("Successfully");
      onSubmited();
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };
  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full">
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white">
                {item ? "Update Index" : "Create Index"}
              </h3>
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={togglePopup}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <div className="flex flex-col md:flex-row w-full">
                <div className="w-full p-4 overflow-x-auto shadow-md shadow-slate-300">
                  <form
                    onSubmit={(e) => onSubmitHandler(e)}
                    className="grid gap-4 sm:grid-cols-2 sm:gap-6 [&_input]:outline-none [&_textarea]:outline-none"
                  >
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="index_name"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Index Name
                      </label>
                      <input
                        type="text"
                        name="index_name"
                        disabled={item}
                        value={formValue?.index_name}
                        onChange={handleChange}
                        placeholder="Index Name"
                        required
                        className="disabled:cursor-not-allowed shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    {item && (
                      <>
                        <div className="sm:col-span-2">
                          <label
                            htmlFor="is_activated"
                            className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                          >
                            Status
                          </label>
                          <label className="group inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              name="is_activated"
                              value=""
                              className="sr-only peer"
                              checked={formValue?.is_activated}
                              onChange={handleSwitchChange}
                            />
                            <span className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-blue-600">
                              {formValue?.is_activated && (
                                <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:-100%] inline-flex items-center  text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                                  {formValue?.is_activated}
                                </span>
                              )}
                              {!formValue?.is_activated && (
                                <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:70%] inline-flex items-center  text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                                  {formValue?.is_activated}
                                </span>
                              )}
                            </span>
                          </label>
                        </div>
                        {formValue.is_activated && (
                          <>
                            <div className="sm:col-span-1">
                              <label
                                htmlFor="priority"
                                className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                              >
                                Priority
                              </label>
                              <input
                                type="number"
                                name="priority"
                                value={formValue?.priority}
                                onChange={handleChange}
                                placeholder="priority"
                                required
                                className="disabled:cursor-not-allowed shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              />
                            </div>
                            <div className="sm:col-span-2">
                              <label
                                htmlFor="allow_conflict_resolution"
                                className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                              >
                                Allow Conflict Resolution
                              </label>
                              <label className="group inline-flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  name="allow_conflict_resolution"
                                  value=""
                                  className="sr-only peer"
                                  checked={formValue?.allow_conflict_resolution}
                                  onChange={handleSwitchChange}
                                />
                                <span className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-blue-600">
                                  {formValue?.allow_conflict_resolution && (
                                    <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:-100%] inline-flex items-center  text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                                      {formValue?.allow_conflict_resolution}
                                    </span>
                                  )}
                                  {!formValue?.allow_conflict_resolution && (
                                    <span className="opacity-0 transition-all duration-300 group-hover:opacity-80 group-hover:[translate:70%] inline-flex items-center  text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full ">
                                      {formValue?.allow_conflict_resolution}
                                    </span>
                                  )}
                                </span>
                              </label>
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {!item && (
                      <div className="sm:col-span-1">
                        <button
                          disabled={loading}
                          type="button"
                          onClick={() => fileInputRef.current.click()}
                          className="inline-flex gap-2 text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          <IconSource className="size-5" />
                          <span> Upload Document</span>
                        </button>
                        <input
                          hidden
                          type="file"
                          ref={fileInputRef}
                          onChange={handleUpload}
                          // accept="text/csv, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                      </div>
                    )}

                    <div className="flex justify-center sm:col-span-2">
                      <button
                        disabled={loading}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        {item ? "Update" : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
